/* eslint-disable indent */
import { html, css, LitElement } from 'lit';
import { customElement, state, query } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { store } from '../../store/store.js';
import sharedStyles from '../../app/styles.js';
import { loadOsItemsIfNeeded } from '../../store/os/os.js';
import { previewElearning } from '../../store/preview/preview.js';
import { navigate } from '../../store/route/route.js';
import { translate } from '../../helpers/translate.js';
import { renderTimestamp } from '../../helpers/controls.js';
import '@lit-labs/virtualizer';
import '@polymer/app-layout/app-layout.js';
import '@vaadin/context-menu/theme/material/vaadin-context-menu.js';
import '@sdb-develop/learning-frontend';
import '../shared/sdb-search-input.js';
import '../shared/sdb-loading.js';
import '../shared/sdb-status-message.js';
import '../shared/sdb-dialog.js';
@customElement('sdb-os-item-list')
class SdbOsItemList extends connect(store)(LitElement) {

    @state()
    accessor osItems;

    @state()
    accessor total;

    @state()
    accessor search;

    @state()
    accessor isLoadingFirstTime;

    @state()
    accessor user;

    @state()
    accessor args;

    stateChanged(state) {
        this.osItems = state.os.list || [];
        this.total = state.os.total;
        this.search = state.os.search;
        this.isLoadingFirstTime = state.os.status === 'loading' && state.os.page === -1;
    }

    static styles = [
        sharedStyles,
        css`
            :host {
                max-width: var(--tcg-content-max-width);
                width: 100%;
            }

            .right-nav-bar {
                display:flex;
                align-items: center;
                justify-content: space-between;
            }

            sdb-search-input {
                flex-grow: 1;
            }

            sdb-content-iconbutton {
                margin-left: 10px;
            }

            #os_items_list {
                contain: none !important; /* lit-virtualizer hack */
            }

            sdb-content-listitem {
                width: 100%; /* lit-virtualizer screws this up */
            }



            .no-results {
                width: 100%;
                max-width: var(--tcg-content-max-width);
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            #no_results_img {
                width: 400px;
                height: 400px;
                background-color: var(--tcg-secondary-background-color);
            }
        `,
    ];

    render() {
        if (this.isLoadingFirstTime) {
            return html`<sdb-loading></sdb-loading>`;
        }

        return html`
            <sdb-layout-60-40>
                <sdb-nav-titlebar slot="left">
                    <span>${translate('headerOsItems')}</span>
                    <span ?hidden=${!this.total}>&nbsp;(${this.total})</span>
                </sdb-nav-titlebar>
                <div class="right-nav-bar" slot="right">
                    <sdb-search-input
                        placeholder=${translate('search')}
                        value=${this.search}
                        @search=${(e) => { store.dispatch(loadOsItemsIfNeeded({ search: e.detail.searchText, reload: true })); }}>
                    </sdb-search-input>
                </div>
            </sdb-layout-60-40>
            <sdb-layout-100>
                ${!this.total
                    ? html`<sdb-status-message label=${translate('noOsItemsFound')}></sdb-status-message>`
                    : html`
                        <sdb-content-list separator>
                            <lit-virtualizer
                                id="os_items_list"
                                .items=${this.osItems}
                                .renderItem=${(osItem, index) => this._renderOsItemListItem(osItem, index)}
                                .scrollTarget=${document}>
                            </lit-virtualizer>
                        </sdb-content-list>
                    `
                }
            </sdb-layout-100>
        `;
    }

    firstUpdated() {
        this.dispatchEvent(
            new CustomEvent('fullscreen', {
                bubbles: true,
                composed: true,
                detail: {
                    fullscreen: false,
                },
            }),
        );
    }

    _renderOsItemListItem(osItem, index) {
        store.dispatch(loadOsItemsIfNeeded({ index }));

        const menuItems = [
            {
                text: translate('preview'),
                action: () => store.dispatch(previewElearning({ item: osItem })),
            },
        ];

        return html`
            <sdb-content-listitem
                icon="fal fa-square-o"
                .headline=${osItem.title}
                .subtitle=${this._getSubtitle(osItem)}
                @click=${()=> { store.dispatch(navigate(`ositem/${osItem.targetId}`)); }}>

                <sdb-content-chipbar slot="chipbar">
                    <sdb-content-chip label="catalogus" ?hidden=${osItem.elearningType !== 0}></sdb-content-chip>
                </sdb-content-chipbar>

                <vaadin-context-menu
                    slot="secondaryAction"
                    open-on="click"
                    .items=${menuItems}
                    @item-selected=${(e) => {
                        e.stopPropagation();
                        e.detail.value?.action?.();
                    }}>
                    <sdb-content-iconbutton icon="fal fa-ellipsis-vertical"></sdb-content-iconbutton>
                </vaadin-context-menu>

            </sdb-content-listitem>
        `;
    }

    _getSubtitle(osItem) {
        var s = `${translate('lastModified')}: ${renderTimestamp(osItem.lastModified)}`;
        if (osItem.supplier && osItem.supplier.supplierKey) {
            s += ` | ${osItem.supplier.name}`;
        }
        if (osItem.description) {
            s += ` | ${osItem.description}`;
        }
        return s;
    }
}
